import { Route } from "react-router-dom";
import BrowseScreen from "./BrowseScreen";

export const routes = (
  <>
    <Route
      key="browse"
      path="browse/:slug_1?/:slug_2?/:slug_3?"
      Component={BrowseScreen}
    />
    <Route
      key="books"
      path="books/:slug_1?/:slug_2?/:slug_3?"
      Component={BrowseScreen}
    />
    <Route
      key="creators"
      path="creators/:slug_1?/:slug_2?/:slug_3?"
      Component={BrowseScreen}
    />
    <Route
      key="bundles"
      path="bundles/:slug_1?/:slug_2?/:slug_3?"
      Component={BrowseScreen}
    />
  </>
);
